import {Button, Checkbox, Col, Divider, Input, Popconfirm, Popover, Radio, Row, Select, Slider, Tooltip} from 'antd';

import '../../asset/style/workflow/slot-component.css';

import {
    ArrowLeftOutlined,
    BorderOutlined,
    CheckOutlined,
    InfoCircleOutlined,
    RedoOutlined,
    RightSquareOutlined,
    UndoOutlined
} from '@ant-design/icons';
import {
    AddCircleTwoTone, EditTwoTone
} from "@mui/icons-material";
import {Stack, Grid, Chip, IconButton} from "@mui/material";
import ReactRegionSelect from 'react-region-select';
import { scanOutputFormat } from "./slots";
import {
    brushType,
    objectiveType,
    scanSpeed,
    specimenType,
    SlotRegionSelectionConstants,
    brushShape,
    DisplaySettingType
} from "../../utils/const";
import { getOverlayedMaskForPath } from './preview_utils';
import { store } from "../../helper/store";
import { RegionSelectionConstants} from "../../redux_constants/region_selection.constant"
import { onAddFocusPoint, setDropDistancePoint } from '../../redux_actions/preview_status.action';
import { notNull, clipValue, getStateAwareUrl, isNull } from "../../utils/utils";
import CircleTwoToneIcon from '@mui/icons-material/CircleTwoTone';
import SquareTwoToneIcon from '@mui/icons-material/SquareTwoTone';
import {Link} from 'react-router-dom';
import {
    autoExportPostScanApp,
    checkAbstractAppPermission,
} from "../utils/abstract_app_maker";
import { get, post } from 'helper/request';
import {canCreateDisplaySettings, isOwner} from 'component/gammaviewer/utils/displaySettingsUtils';
import { aclPermissions, hasPermissions } from 'const/ACLPermissions';
import React from "react";

const ButtonGroup = Button.Group;

export const getBrushPanel = (brushTypeVal, brushSize, onBrushToolChange, onBrushSizeChange) => {
    return [<Row key={0} style={{padding: 10}}>
        <Radio.Group defaultValue={brushType.BRUSH} value={brushTypeVal} buttonStyle="solid"
                     onChange={onBrushToolChange} className={'radio-group-button'}>
            <Radio.Button value={brushType.REDRAW}>Redraw</Radio.Button>
            <Radio.Button value={brushType.BRUSH}>Brush</Radio.Button>
            <Radio.Button value={brushType.ERASER}>Eraser</Radio.Button>
        </Radio.Group>
    </Row>, <Row key={1}>
        <Col span={4} offset={10}>
            <Row style={{fontSize: 13}}>Brush Size</Row>
            <Slider defaultValue={brushSize} onChange={onBrushSizeChange} max={50} min={1}/>
        </Col>
    </Row>]
}

export const getVerticalBrushPanel = (brushTypeVal, brushSize, onBrushToolChange, onBrushSizeChange, brushShapeVal, onBrushShapeChange) => {
    return [<Row key={0} className="side-panel-section" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <IconButton onClick={() => onBrushShapeChange(brushShape.SQUARE)}>
            <SquareTwoToneIcon sx={{fontSize: 25, color: brushShapeVal === brushShape.SQUARE ? "#000" : "white"}}/>
        </IconButton>
        <IconButton onClick={() => onBrushShapeChange(brushShape.CIRCLE_S)}
                    disabled={brushTypeVal === brushType.ERASER}>
            <CircleTwoToneIcon
            sx={{
                fontSize: 15,
                color: brushTypeVal === brushType.ERASER ? "lightgray" : brushShapeVal === brushShape.CIRCLE_S ? "#000" : "white",
            }}/>
        </IconButton>
        <IconButton onClick={() => onBrushShapeChange(brushShape.CIRCLE_M)}
                    disabled={brushTypeVal === brushType.ERASER}>
            <CircleTwoToneIcon
            sx={{
                fontSize: 25,
                color: brushTypeVal === brushType.ERASER ? "lightgray" : brushShapeVal === brushShape.CIRCLE_M ? "#000" : "white"
            }}/>
        </IconButton>
        <IconButton onClick={() => onBrushShapeChange(brushShape.CIRCLE_L)}
                    disabled={brushTypeVal === brushType.ERASER}>
            <CircleTwoToneIcon
            sx={{
                fontSize: 35,
                color: brushTypeVal === brushType.ERASER ? "lightgray" : brushShapeVal === brushShape.CIRCLE_L ? "#000" : "white"
            }}/>
        </IconButton>
    </Row>,
        <Row key={1} className="side-panel-section">
        <Radio.Group size="small" defaultValue={brushType.BRUSH} value={brushTypeVal} buttonStyle="solid"
                     onChange={onBrushToolChange} className={'radio-group-button'}>
            <Radio.Button value={brushType.REDRAW} style={{width: 100, textAlign: 'center'}}
                          className={brushTypeVal === brushType.REDRAW ? "black-scanner-btn" : ""}>REDO</Radio.Button>
            <Radio.Button value={brushType.BRUSH} style={{width: 80, textAlign: 'center'}}
                          className={brushTypeVal === brushType.BRUSH ? "black-scanner-btn" : ""}>Brush</Radio.Button>
            <Radio.Button value={brushType.ERASER} style={{width: 80, textAlign: 'center'}}
                          className={brushTypeVal === brushType.ERASER ? "black-scanner-btn" : ""}>Eraser</Radio.Button>
        </Radio.Group>
    </Row>, <Row key={1} className="side-panel-section">
        <Col>
            <Row className="arial-font" style={{fontSize: 13}}>
                <Col span={8} style={{marginTop: 10}}>
                    <b>Stroke Size</b>
                </Col>
                <Col span={16}>
                    <Slider
                        defaultValue={brushSize}
                        onChange={onBrushSizeChange}
                        disabled={brushShapeVal !== brushShape.SQUARE}
                        max={50}
                        min={1}
                        className="brush-size-slider"
                    />
                </Col>
            </Row>
        </Col>
    </Row>]
}

export const getSpeedPanel = (onScanSpeedChange, preview) => {
    return <Row>
        <Col span={24}>
            <br></br>
            <Row>
                <Row className="arial-font" style={{fontSize: 13}}><b>Select Tissue Artifacts Level</b></Row>
                <Radio.Group defaultValue={scanSpeed.FAST} value={(preview.speed || '').toUpperCase()}
                             buttonStyle="solid" onChange={onScanSpeedChange} className={'radio-group-button'}
                             size="small"
                >
                    <Radio.Button className={preview.speed === scanSpeed.FAST ? "black-scanner-btn" : ""}
                                  value={scanSpeed.FAST} style={{width: 87, textAlign: 'center'}}>Minor</Radio.Button>
                    <Radio.Button className={preview.speed === scanSpeed.MEDIUM ? "black-scanner-btn" : ""}
                                  value={scanSpeed.MEDIUM} style={{width: 87, textAlign: 'center'}}>Few</Radio.Button>
                    <Radio.Button className={preview.speed === scanSpeed.SLOW ? "black-scanner-btn" : ""}
                                  value={scanSpeed.SLOW} style={{width: 87, textAlign: 'center'}}>Major</Radio.Button>
                </Radio.Group>
            </Row>
        </Col>
    </Row>
}

export const getZStackConfigPanel = (onZStackLevelChange, onStepSizeChange, preview) => {
    if ((preview.speed || '').toUpperCase() === scanSpeed.ZSTACK) {
        return [<Row key={0} style={{padding: 10}}>
            <Row style={{fontSize: 13}}>
                <Col span={2} offset={7}>
                    Z Stack Levels
                </Col>
                <Col span={2}>
                    <Input value={preview.zStackLevels} placeholder={10} onChange={onZStackLevelChange}/>
                </Col>
                <Col span={2}>
                    Step Size
                </Col>
                <Col span={2}>
                    <Input value={preview.stepSize} placeholder={0.5} onChange={onStepSizeChange}/>
                </Col>
            </Row>
        </Row>]
    } else {
        return [];
    }
}

export const getButtonsPanel = (status, onConfirm, onRetakePreview, clearSelection, selectFullRegion, regions, cassetteSize) => {
    let confirmButton = null;
    let showConfirm = cassetteSize > 1 || status !== RegionSelectionConstants.SELECTION_DONE;
    if (showConfirm) {
        confirmButton = [<Col span={2} key={0}>
            <Row key={0} style={{paddingTop: 10}}>
                <Button
                    disabled={regions === undefined}
                    onClick={onConfirm}
                    shape="circle">
                    <CheckOutlined/>
                </Button>
            </Row>
            <Row key={1} style={{fontSize: 13}}>Click to Confirm</Row>
        </Col>];
    }

    let colOffset = showConfirm ? 8 : 9;

    return (<Row key={0}>
        <Col span={2} offset={colOffset}>
            <Row key={0} style={{paddingTop: 10}}>
                <Button shape="circle"
                        onClick={onRetakePreview}
                        disabled={status === RegionSelectionConstants.GETTING_IMAGE}>
                    <UndoOutlined/>
                </Button>
            </Row>
            <Row key={1} style={{fontSize: 13}}>Retake Preview</Row>
        </Col>
        {confirmButton}
        <Col span={2}>
            <Row key={0} style={{paddingTop: 10}}>
                <Button
                    shape="circle"
                    disabled={status !== RegionSelectionConstants.SELECTION_DONE}
                    onClick={clearSelection}>
                    <ArrowLeftOutlined/>
                </Button>
            </Row>
            <Row key={1} style={{fontSize: 13}}>Clear Selection</Row>
        </Col>
        <Col span={2}>
            <Row key={0} style={{paddingTop: 10}}>
                <Button
                    shape="circle"
                    disabled={status === RegionSelectionConstants.SELECTION_DONE}
                    onClick={selectFullRegion}>
                    <BorderOutlined/>
                </Button>
            </Row>
            <Row key={1} style={{fontSize: 13}}>Full Scan</Row>
        </Col>
    </Row>);
}

export const getConfirmedPanel = (clearSelection) => {
    return [<Row key={0} style={{fontSize: 18}}>
        Selection Confirmed.
    </Row>, <Row key={1}>
        <Col>
            <Row key={0} style={{paddingTop: 10}}>
                <Button
                    type="danger"
                    shape="circle"
                    onClick={clearSelection}>
                    <RedoOutlined/>
                </Button>
            </Row>
            <Row key={1} style={{fontSize: 13}}>Click to Redo</Row>
        </Col>
    </Row>];
}

export const getBlankSlidePanel = (clearSelection) => {
    return [<Row key={1}>
        <Col>
            <Row key={0} style={{paddingTop: 10}}>
                <Button
                    type="primary"
                    shape="circle"
                    onClick={clearSelection}/>
                <RightSquareOutlined/>
            </Row>
            <Row key={1} style={{fontSize: 13}}>Move to Selection</Row>
        </Col>
    </Row>];
}

export const getAdminPanel = (preview, toggleTiling, toggleTilingAfterScan) => {
    return <Row>
        <Col span={24}>
            <br></br>
            <Row style={{fontSize: 13}}><Checkbox checked={preview.doTilingOnly} onClick={toggleTiling}>Do Tiling
                Only</Checkbox></Row>
            <Row style={{fontSize: 13}}><Checkbox checked={preview.doTilingAfterScan} onClick={toggleTilingAfterScan}>Do
                Tiling After Scan</Checkbox></Row>
        </Col>
    </Row>
}

export const getAutoExportPanel = (preview, toggleExporting, autoExport) => {

    const showAutoExport = checkAbstractAppPermission(autoExportPostScanApp);
    return showAutoExport ? <Row>
        <Col span={24}>
            <Row style={{fontSize: 13}}><Checkbox checked={autoExport} onClick={toggleExporting}>Auto Export After
                Scan</Checkbox></Row>
        </Col>
    </Row> : null
}

export const specimenTypeOptions = (specimenTypesToShow, selectedSpecimenType="") => {
    if (specimenTypesToShow) {
        let retObj = []
        if (specimenTypesToShow.includes("HE")) retObj.push(
            <Radio.Button value={specimenType.HNE_TISSUE} style={{width: 65, textAlign: 'center'}}
                          className={selectedSpecimenType === specimenType.HNE_TISSUE ? "black-scanner-btn" : ""}>HNE
            </Radio.Button>)
        if (specimenTypesToShow.includes("PAP")) retObj.push(
            <Radio.Button value={specimenType.PAP} style={{width: 65, textAlign: 'center'}}
                          className={selectedSpecimenType === specimenType.PAP ? "black-scanner-btn" : ""}>PAP
            </Radio.Button>)
        if (specimenTypesToShow.includes("IHC")) retObj.push(
            <Radio.Button value={specimenType.IHC} style={{width: 65, textAlign: 'center'}}
                          className={selectedSpecimenType === specimenType.IHC ? "black-scanner-btn" : ""}>IHC
            </Radio.Button>)
        if (specimenTypesToShow.includes("BM")) retObj.push(
            <Radio.Button value={specimenType.BM} style={{width: 65, textAlign: 'center'}}
                          className={selectedSpecimenType === specimenType.BM ? "black-scanner-btn" : ""}>BM
            </Radio.Button>)
        if (specimenTypesToShow.includes("BLOOD")) retObj.push(
            <Radio.Button value={specimenType.BLOOD} style={{width: 65, textAlign: 'center'}}
                          className={selectedSpecimenType === specimenType.BLOOD ? "black-scanner-btn" : ""}>BLOOD
            </Radio.Button>)
        return retObj;
    }
    return null;
}

export const getSpecimenChooser = (onSpecimenTypeChange, preview) => {
    return <Row>
        <Col span={24}>
            <br></br>
            <Row key={0} style={{padding: 10}}>
                <Row style={{fontSize: 13}}>Set Specimen Type</Row>
                <Radio.Group defaultValue={specimenType.HNE_TISSUE} value={(preview.specimenType || '').toUpperCase()}
                             buttonStyle="solid" onChange={onSpecimenTypeChange}>
                    <Radio.Button value={specimenType.HNE_TISSUE}>HNE</Radio.Button>
                    <Radio.Button value={specimenType.BLOOD}>Blood</Radio.Button>
                    <Radio.Button value={specimenType.PAP}>Pap</Radio.Button>
                    <Radio.Button value={specimenType.IHC}>IHC</Radio.Button>
                    <Radio.Button value={specimenType.BM}>BM</Radio.Button>
                </Radio.Group>
            </Row>
        </Col>
    </Row>
}

export const getStainChooser = (onSpecimenTypeChange, preview, specimenTypesToShow) => {
    return <Row>
        <Col span={24}>
            <br></br>
            <Row>
                <Row className="arial-font" style={{fontSize: 13}}><b>Set Stain Type</b></Row>
                <Radio.Group defaultValue={specimenType.HNE_TISSUE} value={(preview.specimenType || '').toUpperCase()}
                             buttonStyle="solid" onChange={onSpecimenTypeChange} size="small" className={'radio-group-button'}>
                    {specimenTypeOptions(specimenTypesToShow, preview.specimenType)}
                </Radio.Group>
            </Row>
        </Col>
    </Row>
}

export const getObjectiveChooser = (onObjectiveTypeChange, preview) => {
    return <Row>
        <Col span={24}>
            <br></br>
            <Row key={0} style={{padding: 10}}>
                <Row style={{fontSize: 13}}>Set Objective Type</Row>
                <Radio.Group defaultValue={objectiveType.FORTY_X} value={preview.objectiveType} buttonStyle="solid"
                             onChange={onObjectiveTypeChange}>
                    <Radio.Button value={objectiveType.FORTY_X}>40X</Radio.Button>
                    {/* <Radio.Button value={objectiveType.TWENTY_X}>20X</Radio.Button> */}
                </Radio.Group>
            </Row>
        </Col>
    </Row>
}

export const getScanOutputFormatChanger = (onScanOutputFormatChange, preview) => {
    return <Row>
        <Col span={24}>
            <br></br>
            <Row key={0} style={{padding: 10}}>
                <Row style={{fontSize: 13}}>Choose Scan Format</Row>
                <Radio.Group defaultValue={scanOutputFormat.JPG} value={preview.scanOutputFormat} buttonStyle="solid"
                             onChange={onScanOutputFormatChange}>
                    <Radio.Button value={scanOutputFormat.JPG}>JPG</Radio.Button>
                    <Radio.Button value={scanOutputFormat.PNG}>PNG</Radio.Button>
                </Radio.Group>
            </Row>
        </Col>
    </Row>
}

export const getCanvasComponent = (status, id, previewCanvasRef, thresholdCanvasRef, regions, onCanvasChange, allowPainting,
                                   startPainting, paintCanvas, stopPainting, dropDistanceCanvas, dropDistanceCanvasRef, focusPointsCanvas, focusPointsCanvasRef,
                                   preview, slot, deviceId) => {

    const regionStyle = {
        background: 'rgba(255, 0, 0, 0)', zIndex: 1
    };

    let date = new Date();

    if (!Array.isArray(regions)) {
        regions = undefined;
    }

    return <Col style={{alignItems: "center"}} span={14} offset={2}>
        {status === RegionSelectionConstants.FETCHED_IMAGE ?
            <ReactRegionSelect
                style={{zIndex: 1}}
                maxRegions={1}
                regions={regions}
                regionStyle={regionStyle}
                constraint
                onChange={onCanvasChange}>
                <div id="scan-preview" className="preview-canvas-wrapper">
                    <canvas ref={previewCanvasRef} className="region-selection-canvas"/>
                    <canvas ref={thresholdCanvasRef} className="region-selection-canvas"/>
                </div>
            </ReactRegionSelect> : status === RegionSelectionConstants.CONFIRMED ?
                <div>
                    <img src={getOverlayedMaskForPath(id) + '?id=' + date.getTime()}
                         style={{height: '192px', width: '576px'}}/>
                </div> :
                status === RegionSelectionConstants.START_DROP_DISTANCE_SELECTION ?
                    <div style={{zIndex: 1, marginBottom: "8px"}} className="preview-canvas-wrapper">
                        <canvas ref={previewCanvasRef} className="region-selection-canvas"/>
                        <canvas id={"thresholdCanvas" + id}
                                ref={thresholdCanvasRef}
                                className="region-selection-canvas"/>
                        <canvas id={"dropDistanceCanvas" + id}
                                onMouseDown={(e) => drawCrossHair(e, dropDistanceCanvas, {
                                    clearCanvas: true,
                                    color: 'red',
                                    size: 10,
                                    width: 1
                                }, preview, slot)}
                                ref={dropDistanceCanvasRef}
                                className="region-selection-canvas"/>
                    </div> :
                    status === RegionSelectionConstants.START_FOCUS_POINTS_SELECTION ?
                        <div style={{zIndex: 1, marginBottom: "8px"}} className="preview-canvas-wrapper">
                            <canvas ref={previewCanvasRef} className="region-selection-canvas"/>
                            <canvas id={"thresholdCanvas" + id}
                                    ref={thresholdCanvasRef}
                                    className="region-selection-canvas"/>
                            <canvas id={"focusPointsCanvas" + id}
                                    onClick={(e) => store.dispatch(onAddFocusPoint(e, deviceId, slot, preview, focusPointsCanvas))}
                                    ref={focusPointsCanvasRef}
                                    className="region-selection-canvas"/>
                        </div> :
                        <div style={{zIndex: 1, marginBottom: "8px"}} className="preview-canvas-wrapper">
                            <canvas ref={previewCanvasRef} className="region-selection-canvas"/>
                            <canvas id={"thresholdCanvas" + id}
                                    onMouseDown={allowPainting ? startPainting : undefined}
                                    onMouseMove={allowPainting ? paintCanvas : undefined}
                                    onMouseUp={allowPainting ? stopPainting : undefined}
                                    ref={thresholdCanvasRef}
                                    className="region-selection-canvas"/>
                        </div>
        }
    </Col>
}

export const getCanvasComponentNew = (status, previewCanvasRef, thresholdCanvasRef, brushEraserPrevCanvasRef, regions, onCanvasChange, allowPainting,
                                      startPainting, paintCanvas, stopPainting, dropDistanceCanvas, dropDistanceCanvasRef, focusPointsCanvas, focusPointsCanvasRef,
                                      preview, slot, deviceId, brushTypeVal, showBrushOrEraserSize) => {

    const regionStyle = {
        background: 'rgba(255, 0, 0, 0)', zIndex: 1
    };

    if (!Array.isArray(regions)) {
        regions = undefined;
    }

    const h = document.getElementById("thresholdCanvas" + slot)?.offsetHeight
    const w = document.getElementById("thresholdCanvas" + slot)?.offsetWidth
    const height = notNull(h) ? h+"px" : "auto"
    const width = notNull(w) ? w+"px" : "auto"

    return <Col style={{display: "flex", justifyContent:"center"}}>
        {brushTypeVal === brushType.REDRAW ?
            <ReactRegionSelect
                style={{zIndex: 1}}
                className="react-region-select-custom--style"
                maxRegions={1}
                regions={regions}
                regionStyle={regionStyle}
                constraint
                onChange={onCanvasChange}>
                <div id="scan-preview" className="preview-canvas-wrapper-new" style={{height:height, width:width}}>
                    <canvas ref={previewCanvasRef} className="region-selection-canvas-new"/>
                    <canvas id={"thresholdCanvas" + slot} ref={thresholdCanvasRef}
                            className="region-selection-canvas-new"/>
                </div>
            </ReactRegionSelect> :
            // status === RegionSelectionConstants.CONFIRMED ?
            //     <div>
            //         <img src={getOverlayedMaskForPath(slot) + '?id=' + date.getTime()}
            //              style={{height: '192px', width: '576px'}}/>
            //     </div> :
                status === RegionSelectionConstants.START_DROP_DISTANCE_SELECTION ?
                    <div style={{zIndex: 1}} className="preview-canvas-wrapper-new">
                        <canvas ref={previewCanvasRef} className="region-selection-canvas-new"/>
                        <canvas id={"thresholdCanvas" + slot}
                                ref={thresholdCanvasRef}
                                className="region-selection-canvas-new"/>
                        <canvas id={"dropDistanceCanvas" + slot}
                                onMouseDown={(e) => drawCrossHair(e, dropDistanceCanvas, {
                                    clearCanvas: true,
                                    color: 'red',
                                    size: 10,
                                    width: 1
                                }, preview, slot)}
                                ref={dropDistanceCanvasRef}
                                className="region-selection-canvas-new"/>
                    </div> :
                    status === RegionSelectionConstants.START_FOCUS_POINTS_SELECTION ?
                        <div style={{zIndex: 1}} className="preview-canvas-wrapper-new">
                            <canvas ref={previewCanvasRef} className="region-selection-canvas-new"/>
                            <canvas id={"thresholdCanvas" + slot}
                                    ref={thresholdCanvasRef}
                                    className="region-selection-canvas-new"/>
                            <canvas id={"focusPointsCanvas" + slot}
                                    onClick={(e) => store.dispatch(onAddFocusPoint(e, deviceId, slot, preview, focusPointsCanvas))}
                                    ref={focusPointsCanvasRef}
                                    className="region-selection-canvas-new"/>
                        </div> :
                        <div style={{zIndex: 1}} className="preview-canvas-wrapper-new">
                            <canvas ref={previewCanvasRef} className="region-selection-canvas-new"/>
                            <canvas id={"thresholdCanvas" + slot}
                                    ref={thresholdCanvasRef}
                                    className="region-selection-canvas-new"/>
                            <canvas id={"brushEraserPrevCanvas" + slot}
                                    onMouseDown={allowPainting ? startPainting : undefined}
                                    onMouseMove={allowPainting ? paintCanvas : showBrushOrEraserSize}
                                    onMouseOut={allowPainting ? stopPainting : undefined}
                                    onMouseUp={allowPainting ? stopPainting : undefined}
                                    ref={brushEraserPrevCanvasRef}
                                    className="brush-eraser-prev-canvas-new"/>
                        </div>
        }
    </Col>
}

const createThresholdedCanvas = (thresholdCanvas, thresholdedPath, regions, cleanupExtraCallback, loc = "/dev-ssd/") => {

    // //TODO: @Spandan Fix this after backend changes

    const thresholdContext = thresholdCanvas.getContext('2d');
    const thresholdImage = new Image();
    thresholdImage.src = getStateAwareUrl(loc + thresholdedPath);
    thresholdImage.onload = () => {
        thresholdContext.filter = "brightness(180%)"
        thresholdContext.clearRect(0, 0, thresholdCanvas.width, thresholdCanvas.height);
        thresholdContext.drawImage(thresholdImage, 0, 0, thresholdCanvas.width, thresholdCanvas.height);

        var img =thresholdContext.getImageData(0, 0, thresholdCanvas.width, thresholdCanvas.height);
        for (var t=0;t< img.data.length;t+=4) {
            if(img.data[t] > 0) {
                img.data[t] = SlotRegionSelectionConstants.SELETION_FILL.RED;
                img.data[t+1] = SlotRegionSelectionConstants.SELETION_FILL.GREEN;
                img.data[t+2] = SlotRegionSelectionConstants.SELETION_FILL.BLUE;
                img.data[t+3] = SlotRegionSelectionConstants.SELETION_FILL.ALPHA;
            }   else {
                img.data[t] = 0;
                img.data[t+1] = 0;
                img.data[t+2] = 0;
                img.data[t+3] = 0;
            }
        }

        img = createBorderOnThresholdedCanvas(img);

        thresholdContext.putImageData(img,0,0); // Image data is adjusted according to context

        cleanupExtraCallback();
    }
    thresholdContext.globalAlpha = 1;
}

export const cleanThresholdBorder = (img, startX = 0, startY = 0, endX = null, endY = null) => {

    if(!endX) endX = img.width;
    if(!endY) endY = img.height;

    startX = clipValue(startX, 0, img.width);
    startY = clipValue(startY, 0, img.height);
    endX = clipValue(endX, 0, img.width);
    endY = clipValue(endY, 0, img.height);

    for (var x=startX; x<endX ; x+=1) {
        for (var y=startY; y<endY ; y+=1) {
            let pixelIdx = (x+y*img.width)*4
            if(img.data[pixelIdx + 3] === 255) {
                    img.data[pixelIdx] = 0;
                    img.data[pixelIdx+1] = 0;
                    img.data[pixelIdx+2] = 0;
                    img.data[pixelIdx+3] = 0;
            }
        }
    }
    return img
}

export const createBorderOnThresholdedCanvas = (img, startX = 0, startY = 0, endX = null, endY = null) => {
    let dArr = [-1,-1, 0,-1, 1,-1, -1,0, 1,0, -1,1, 0,1, 1,1] // offset array
    let scale = 1  // thickness scale

    if(!endX) endX = img.width;
    if(!endY) endY = img.height;

    startX = clipValue(startX, 0, img.width);
    startY = clipValue(startY, 0, img.height);
    endX = clipValue(endX, 0, img.width);
    endY = clipValue(endY, 0, img.height);

    // draw images at offsets from the array scaled by s
    for (var x=startX; x<endX ; x+=1) {
        for (var y=startY; y<endY; y+=1) {

            let pixelAlphaIdx = (x+y*img.width)*4+3

            for(var i=0; i < dArr.length && img.data[pixelAlphaIdx] > 0 && img.data[pixelAlphaIdx] < 255 && img.data[pixelAlphaIdx-3] > 0; i += 2) {
                let newX = x + dArr[i]*scale;
                let newY = y + dArr[i+1]*scale;
                let newPixelStartIdx = (newX+newY*img.width)*4
                if(img.data[newPixelStartIdx+3] === 0) {
                    img.data[newPixelStartIdx] = SlotRegionSelectionConstants.SELECTION_BORDER.RED;
                    img.data[newPixelStartIdx+1] = SlotRegionSelectionConstants.SELECTION_BORDER.GREEN;
                    img.data[newPixelStartIdx+2] = SlotRegionSelectionConstants.SELECTION_BORDER.BLUE;
                    img.data[newPixelStartIdx+3] = SlotRegionSelectionConstants.SELECTION_BORDER.ALPHA;
                }
            }
        }
    }

    return img;
}

export const prepareThresholdImageForSave = (thresholdCanvas) => {
    const thresholdContext = thresholdCanvas.getContext('2d');

    var img =thresholdContext.getImageData(0, 0, thresholdCanvas.width, thresholdCanvas.height);
        for (var t=0;t< img.data.length;t+=4) {
            if(img.data[t] === 0 && img.data[t+1] > 200 && img.data[t+2] === 0) {
                continue;
            }

            if(img.data[t+3] === 255 || img.data[t+3] === 0) {
                img.data[t] = 0;
                img.data[t+1] = 0;
                img.data[t+2] = 0;
                img.data[t+3] = 0;
            } else if(img.data[t+3] > 0) {
                img.data[t] = 255;
                img.data[t+1] = 255;
                img.data[t+2] = 255;
                img.data[t+3] = 255;
            }
         }
    thresholdContext.putImageData(img,0,0); // Image data is adjusted according to context
}

export const cleanUpExtra = (thresholdCanvas, thresholdContext, reg) => {

    if (isNull(thresholdContext)) return;

    // Get Region Coordinates in Absolute Coordinates from Percentages
    let x1 = parseInt((reg.x * thresholdCanvas.width) / 100.0);
    let x2 = parseInt(((reg.x + reg.width) * thresholdCanvas.width) / 100.0);
    let y1 = parseInt((reg.y * thresholdCanvas.height) / 100.0);
    let y2 = parseInt(((reg.y + reg.height) * thresholdCanvas.height) / 100.0);

    // Clear surrounding boxes

    thresholdContext.clearRect(0, 0, x1, thresholdCanvas.height);
    thresholdContext.clearRect(x1, 0, thresholdCanvas.width - x1, y1);
    thresholdContext.clearRect(x2, y1, thresholdCanvas.width - x2, thresholdCanvas.height - y1);
    thresholdContext.clearRect(x1, y2, x2 - x1, thresholdCanvas.height - y2);

    // Fill surrounding with black
    thresholdContext.fillStyle = SlotRegionSelectionConstants.BLANK.RGBA;
    thresholdContext.fillRect(0, 0, x1, thresholdCanvas.height);
    thresholdContext.fillRect(x1, 0, thresholdCanvas.width - x1, y1);
    thresholdContext.fillRect(x2, y1, thresholdCanvas.width - x2, thresholdCanvas.height - y1);
    thresholdContext.fillRect(x1, y2, x2 - x1, thresholdCanvas.height - y2);

    // Create boundary
    thresholdContext.beginPath();
    let strokeSize = 10;
    let lineWidth = 0.05 * strokeSize;
    thresholdContext.lineWidth = lineWidth;
    thresholdContext.strokeStyle = "rgba(0,255,0,1)";
    thresholdContext.rect(Math.max(0, x1-lineWidth), Math.max(0, y1-lineWidth), x2 - x1 + 2*lineWidth, y2 - y1 + 2*lineWidth);
    thresholdContext.stroke();
}

const contrastImage = (imgData, contrast) => {  //input range [0..100]
    contrast = (contrast/100) + 1;  //convert to decimal & shift range: [0..2]
    for(var i=0;i<imgData.data.length;i+=4){   //r,g,b,a
        imgData.data[i] = clipValue( imgData.data[i]*contrast, 0, 255);
        imgData.data[i+1] = clipValue( imgData.data[i+1]*contrast, 0, 255);
        imgData.data[i+2] = clipValue( imgData.data[i+2]*contrast, 0, 255);
    }
    return imgData;
}

const saturateImage = (imgData, sv)=> { // saturation value. 0 = grayscale, 1 = original

    var luR = 0.3086; // constant to determine luminance of red. Similarly, for green and blue
    var luG = 0.6094;
    var luB = 0.0820;

    var az = (1 - sv)*luR + sv;
    var bz = (1 - sv)*luG;
    var cz = (1 - sv)*luB;
    var dz = (1 - sv)*luR;
    var ez = (1 - sv)*luG + sv;
    var fz = (1 - sv)*luB;
    var gz = (1 - sv)*luR;
    var hz = (1 - sv)*luG;
    var iz = (1 - sv)*luB + sv;

    for(var i = 0; i < imgData.data.length; i += 4)
    {
        var red = imgData.data[i]; // Extract original red color [0 to 255]. Similarly for green and blue below
        var green = imgData.data[i + 1];
        var blue = imgData.data[i + 2];

        var saturatedRed = (az*red + bz*green + cz*blue);
        var saturatedGreen = (dz*red + ez*green + fz*blue);
        var saturateddBlue = (gz*red + hz*green + iz*blue);

        imgData.data[i] = saturatedRed;
        imgData.data[i + 1] = saturatedGreen;
        imgData.data[i + 2] = saturateddBlue;
    }

    return imgData
}

export const updateImages = (previewCanvas, previewPath, thresholdCanvas, thresholdedPath, regions, cleanupExtraCallback, retainImage, loc = "/dev-ssd/") => {
    const previewContext = previewCanvas.getContext('2d');
    const previewPathSrc = getStateAwareUrl(loc + previewPath);
    if (!retainImage){
        previewContext.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
        const previewImage = new Image();
        previewImage.src = previewPathSrc;

        previewImage.onload = () => {
            previewCanvas.style.backgroundImage = `url(${previewPathSrc})`
        }
}

    previewCanvas.style.backgroundImage = `url(${previewPathSrc})`
    var img = previewContext.getImageData(0, 0, thresholdCanvas.width, thresholdCanvas.height);
    img = contrastImage(img, 100);
    img = saturateImage(img, 4);
    previewContext.putImageData(img,0,0); // Image data is adjusted according to context

    if (notNull(regions) && regions.length > 0) {
        let reg = regions[0];
        if (notNull((reg || {}).x)) {
            createThresholdedCanvas(thresholdCanvas, thresholdedPath, reg, cleanupExtraCallback, loc);
        }
    }
}

export const drawCrossHair = (event, canvas, opts, preview, slot) => {

    let rect = canvas.getBoundingClientRect();
    let canvasx = rect.x;
    let canvasy = rect.y;
    let mousex = parseInt(((event.pageX - canvasx) / rect.width) * canvas.width);
    let mousey = parseInt(((event.pageY - canvasy) / rect.height) * canvas.height);
    let x = mousex;
    let y = mousey;

    if (x === 0 && y === 0) {
        return;
    }

    x = x - window.scrollX;
    y = y - window.scrollY;

    let canvasContext = canvas.getContext("2d");

    if (opts.clearCanvas === true) {
        canvasContext.clearRect(0, 0, canvas.width, canvas.height);
    }

    if (opts.color === undefined) {
        canvasContext.fillStyle = "#ff0000";
    } else {
        canvasContext.fillStyle = opts.color;
    }

    for (let i = 0; i <= 10; i++) {
        canvasContext.fillRect(x - 5 + i, y, 2, 2);
        canvasContext.fillRect(x, y - 5 + i, 2, 2);
    }

    let realX = Math.trunc(x * (preview.response.previewWidth / canvas.width));
    let realY = Math.trunc(y * (preview.response.previewHeight / canvas.height));

    let dropDistancePoints = [...preview.dropDistancePoint];
    if (dropDistancePoints.length === 3) {
        dropDistancePoints.unshift({x: realX, y: realY});
    } else if (dropDistancePoints.length === 4) {
        dropDistancePoints[0] = {x: realX, y: realY};
    }
    store.dispatch(setDropDistancePoint(slot, dropDistancePoints));
}

export const drawCrossHairInitial = (realX, realY, canvas, opts, preview) => {
    let x = realX / (preview.response.previewWidth / (canvas).width);
    let y = realY / (preview.response.previewHeight / (canvas).height);

    if (x === 0 && y === 0) {
        return;
    }

    x = x - window.scrollX;
    y = y - window.scrollY;

    let canvasContext = canvas.getContext("2d");

    if (opts.clearCanvas === true) {
        canvasContext.clearRect(0, 0, canvas.width, canvas.height);
    }

    if (opts.color === undefined) {
        canvasContext.fillStyle = "#ff0000";
    } else {
        canvasContext.fillStyle = opts.color;
    }

    for (let i = 0; i <= opts.size; i++) {
        canvasContext.fillRect(x - (opts.size / 2) + i, y, opts.width, opts.width);
        canvasContext.fillRect(x, y - (opts.size / 2) + i, opts.width, opts.width);
    }
}

/**
 * Bounds - [x1, x2, y1, y2] - x1, x2, y1, y2 are the percentage of the bounding box from left and top
 * */
export const boundRegions = (regions, isBlood) => {
    let bounds = [1, 99, 0, 100];
    const bloodBounds = [1, 99, 0, 100];

    if (isBlood) {
        bounds = bloodBounds
    }

    if (Array.isArray(regions)) {
        regions.map(region => {
            region.x = Math.max(region.x, bounds[0]);
            region.y = Math.max(region.y, bounds[2]);
            region.width = Math.min(region.width, bounds[1] - region.x);
            region.height = Math.min(region.height, bounds[3] - region.y);
            return region;
        })
    }
    return regions;
}

export const drawCircle = (realX, realY, canvas, opts, preview) => {
    let x = realX / (preview.response.previewWidth / (canvas).width);
    let y = realY / (preview.response.previewHeight / (canvas).height);

    if (x===0 && y===0){
        return;
    }

    x = x-window.scrollX;
    y = y-window.scrollY;

    let canvasContext = canvas.getContext("2d");

    if (opts.clearCanvas === true) {
        canvasContext.clearRect(0, 0, canvas.width, canvas.height);
    }

    if (opts.color === undefined) {
        canvasContext.fillStyle = "#ff0000";
    } else {
        canvasContext.fillStyle = opts.color;
    }

    canvasContext.beginPath()
    canvasContext.arc(x, y, opts.radius, 0, 2 * Math.PI, false)
    canvasContext.fill();

    if (opts.strokeColor !== undefined) {
        canvasContext.strokeStyle = opts.strokeColor;
        canvasContext.strokeWidth = opts.strokeWidth || 2;
        canvasContext.stroke();
    }
}

export const getRecentlyUsedSettings = (recentlyUsedSettings, setting, handleClick) => {
    const showScanSetting = hasPermissions([aclPermissions.update_specimen_setting]);
     if (!recentlyUsedSettings || !setting){
         return null
     }
     console.log(recentlyUsedSettings)
    return showScanSetting ? <Row className="arial-font full-width" style={{fontSize: 13}}>
        <Col style={{fontWeight:"bold"}}>
            Recently Used Settings:
        </Col>
        <Divider />
        {getRecentlyUsedChips(recentlyUsedSettings, setting, handleClick)}
    </Row> : null
}

export const fetchAllDisplaySettings = () => {
    return new Promise((resolve, reject) => {
        const url = `/api/display/settings/?type=${DisplaySettingType.SLIDE}&ordering=-last_used&view=list`;
        get(url)
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            reject(error);
        });
    });
}

export const fetchAllStainSettings = (specimen) => {
    return new Promise((resolve, reject) => {
        post(`/api/populate/stain/settings/`, Object.values(specimen))
        .then(() => {
            get(`/api/stain/settings/`)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
        })
        .catch(error => {
            reject(error);
        });
    });
}

const getRecentlyUsedChips = (settings, curr_setting, handleClick) => {
    return <Grid container>
    {Object.values(settings).slice(0,3).map(setting => {
        let name = setting.name;
        if(setting.name.length > 5){
            name = setting.name.slice(0,5)+"..."
        }
        if (setting.id === getIdFromName(settings, curr_setting)) {
            return <Grid item margin={0.2}>
            <Chip label={name} color="primary"/>
            </Grid>
        }
        else{
            return <Grid item margin={0.2}>
            <Chip label={name} key={setting.id} onClick={() => handleClick(setting.id)}/>
            </Grid>
        }
    }
    )}
    </Grid>
}

export const getSliderRows = (is_superuser, displaySettingsList, selectedDisplaySettings, createSetting, getIndividualSliders) => {
    const showSliderRows = hasPermissions([aclPermissions.update_specimen_setting])

    return showSliderRows ? <Row style={{marginTop: 20, color: 'black'}} span={16}>
        {!isOwner(displaySettingsList[getIdFromName(displaySettingsList, selectedDisplaySettings)]) ?
            <Popconfirm title="These can only be modified by the Settings Owner, Create your own copy of these settings?" onConfirm={createSetting} style={{zIndex: 10000}}>
                {getIndividualSliders(is_superuser)}
            </Popconfirm>
            :
            <React.Fragment>
                {getIndividualSliders(is_superuser)}
            </React.Fragment>
        }
    </Row> : null
}


export const getViewerSettingDropdown = (selected_specimen_type, selected_display_setting, display_setting_list, onChangeCb, showInfo, advanced_mode, createSetting, editSetting, autoPreviewThreshold) => {
    const showScanSetting = hasPermissions([aclPermissions.update_specimen_setting])
    const updateScanSetting = hasPermissions([aclPermissions.update_specimen_setting])
    const createScanSetting = hasPermissions([aclPermissions.create_slide_setting])

    return showScanSetting ? <Row className="arial-font full-width" style={{fontSize: 13}}>
        {advanced_mode && autoPreviewThreshold !== true ? <Row>
            <Col style={{fontWeight:"bold"}}>
                Specimen Type:
            </Col>
            <Col flex="auto">
                <Input value={selected_specimen_type} disabled />
            </Col>
        </Row> : null}
        <Divider />
        <Row style={{fontWeight:"bold"}}>Set Scanning Profile {showInfo ? getSpecimenChangeInfoButton() : null}</Row>
        {advanced_mode ? getAddAndEditSettingButton(selected_display_setting, createScanSetting, updateScanSetting, createSetting, editSetting) : null}
        <Select showSearch className={"full-width"} value={selected_display_setting}
                disabled={!updateScanSetting}
                onChange={(val) => onChangeCb(val)} filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }>
            {display_setting_list && Object.values(display_setting_list).map(setting => {
                return <Select.Option value={setting.id}>
                    {setting.name}
                </Select.Option>
            })
            }
        </Select>
    </Row> : null
}

export const getSpecimenChangeInfoButton = () => {
    return <Popover content={<div>○ Selecting the profile would result in using <br/>
        it for this scan only. <br/>
        ○ You can change the Default Profile in <br/>
        <Link to="/scanning_profile">Default Scanning Profile</Link>.<br/>
        ○ You can change individual values <br/>
        for the profiles in <b>Advanced Mode</b><br/>
        on the top left corner.</div>} trigger="click">
        <InfoCircleOutlined style={{cursor: "pointer", marginLeft: "5px"}} />
    </Popover>
}

export const getAddAndEditSettingButton = (display_setting, createScanSetting, editScanSetting, createSetting, editSetting) => {
    return <Stack direction={"row"} justifyContent={"space-between"}>
				<ButtonGroup>
                    {createScanSetting ?
                        popOverButton("Name", createSetting, "Add a new setting", <AddCircleTwoTone />, "")
                        : null
                    }
                    {editScanSetting ?
                        popOverButton(display_setting, editSetting, "Edit Name of Selected Setting", <EditTwoTone />, display_setting)
                        : null
                    }
				</ButtonGroup>
			</Stack>
}

export const popOverButton = (placeholder, onConfirm, tooltip, icon, value) => {
    return <Popover
        content={<Input.Search
            placeholder={placeholder}
            enterButton="Save"
            defaultValue={value}
            size="small"
            onSearch={value => onConfirm(value)} />}
        title="Enter New Setting Name"
        trigger="click"
    >
        <Tooltip title={tooltip}>
            <Button style={{padding: "5px"}}>
                    {icon}
            </Button>
        </Tooltip>
    </Popover>;
}

export const getNameFromId = (display_setting_list, id) => {
    if (display_setting_list && Object.values(display_setting_list).length > 0) {
        const setting = display_setting_list[id];
        if (setting) {
            return setting.name;
        }
    }
}

export const getIdFromName = (display_setting_list, name) => {
    if (display_setting_list && Object.values(display_setting_list).length > 0) {
        const setting = Object.values(display_setting_list).find(setting => setting.name === name);
        if (setting) {
            return setting.id;
        }
    }
}

export const hasEditSlideSettingPermission = () => hasPermissions([aclPermissions.update_slide_setting])
